export const WARM_WHITE = '#FDFDFD'
export const COLD_PURPLE = '#B3AEDA'
